import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import firebase from "../../node_modules/firebase/compat/app";
import { collection, setDoc, addDoc, getDoc, doc } from "firebase/firestore";
import { firebaseConfig } from "../firebase-config";
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import InstantMessage from './InstantMessage.js';

import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

function OpenAccount() {
    
    const [loginEmail, setLoginEmail] = useState("");
    const [loginPassword, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [EmailError, NewEmailError] = useState(false);
    const [PasswordError, NewPasswordError] = useState(false);
    const [ConfirmPasswordError, NewConfirmPasswordError] = useState(false);

    const [instant, setInstant] = useState(false); // Controls Alert
    const [severity, setSeverity] = useState(''); // Controls Severity
    const [message, setMessage] = useState('') // Controls Message

    const [EmailHT, NewEmailHT] = useState("");
    const [PasswordHT, NewPasswordHT] = useState("");
    const [ConfirmPasswordHT, NewConfirmPasswordHT] = useState("");

    const [disabledConfirm, setDisabledConfirm] = useState(true)

    let navigate = useNavigate();

    const openAcc = async (accountEmail, accountPassword) => {
      const auth = getAuth();
      createUserWithEmailAndPassword(auth, accountEmail, accountPassword)
        .then((userCredential) => {
          const user = userCredential.user
          localStorage.setItem("isAuth", "true");
          navigate("/dashboard");
        })
        .catch((error) => {
          setSeverity("error")
          setMessage("This email is already in use.");
          setInstant(true);
          // ..
        });
      setInstant(false);  
    }

    return (
      <ThemeProvider theme={theme}>
        <Grid>
          {instant ?  <InstantMessage sev = {severity} message = {message} /> : `` }
          <form>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextField type="email" placeholder="NewEmail@email.com" label="Email" variant="outlined" helperText = {EmailHT} fullWidth required 
                onChange={(event) => {
                  setInstant(false); 
                  setLoginEmail(event.target.value);
                  if (event.target.value === "" || ! event.target.value.match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/)){
                    NewEmailHT("Enter a valid email");
                    NewEmailError(true);
                  }
                  else{
                    NewEmailHT("")
                    NewEmailError(false);
                  }
                }}
                error = {EmailError}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField type="password" placeholder="Enter your password" label="Password" variant="outlined" helperText = {PasswordHT} fullWidth required 
                onChange={(event) => {
                  setConfirmPassword("")
                  setInstant(false); 
                  setPassword(event.target.value);
                  if (event.target.value === "" || event.target.value.length < 8){
                    NewPasswordHT("Password must be at least 8 characters.");
                    NewPasswordError(true);
                    setDisabledConfirm(true);
                  }
                  else{
                    NewPasswordHT("")
                    NewPasswordError(false);
                    setDisabledConfirm(false);
                  }
                }}
                error = {PasswordError}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField type="password" value={confirmPassword} disabled={disabledConfirm} placeholder="Re-enter your password" label="Confirm Password" variant="outlined" helperText = {ConfirmPasswordHT} fullWidth required 
                onChange={(event) => {
                  setInstant(false); 
                  setConfirmPassword(event.target.value);
                  if (event.target.value !== loginPassword){
                    NewConfirmPasswordHT("Password does not match.");
                    NewConfirmPasswordError(true);
                  }
                  else{
                    NewConfirmPasswordHT("")
                    NewConfirmPasswordError(false);
                  }
                }}
                error = {ConfirmPasswordError}
                />
              </Grid>

              <Grid item xs={12}>
                <Button type="submit" variant="contained" style={{fontFamily: "Segoe UI"}} sx={{ mt:1, mb:2, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'}}} fullWidth
                onClick={e => {
                  e.preventDefault()
                  if(loginEmail  && loginPassword && confirmPassword && !(EmailError  || PasswordError || ConfirmPasswordError)){
                      openAcc(loginEmail,loginPassword)
                  }
                  else{
                    setMessage("Please enter valid email or password.")
                    setSeverity("error")
                    setInstant(true); 
                    if (loginEmail === ""){
                      NewEmailError(true);
                      NewEmailHT("Enter a valid email");
                    }
                    if (loginPassword === ""){
                      NewPasswordHT("Enter a password");
                      NewPasswordError(true);
                    }
                  }
                }}
                >
                Add New Account
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </ThemeProvider>
    )
}

export default OpenAccount